/** Labra display formats shared by date helpers (subset of host constants). */
export const standardLabraTimeFormat = 'HH:MM a ZZZZ'

export const standardLabraDateFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
} as const

export const standardLabraTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZoneName: 'short',
} as const
